var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTimeLimit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dices",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48239",
    "data-name": "Path 48239",
    d: "M251.375,0h-8.2A1.172,1.172,0,0,0,242,1.172V6.393l4.154,4.154h5.221a1.172,1.172,0,0,0,1.172-1.172v-8.2A1.172,1.172,0,0,0,251.375,0ZM245.01,3.6a.586.586,0,1,1,.586-.586A.586.586,0,0,1,245.01,3.6Zm2.263,2.263a.586.586,0,1,1,.586-.586A.586.586,0,0,1,247.273,5.859Zm2.263,2.263a.586.586,0,1,1,.586-.586A.586.586,0,0,1,249.536,8.122Z",
    transform: "translate(-232.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48240",
    "data-name": "Path 48240",
    d: "M13.6,161.159l-5.8-5.8a1.172,1.172,0,0,0-1.657,0l-5.8,5.8a1.172,1.172,0,0,0,0,1.657l5.8,5.8a1.172,1.172,0,0,0,1.657,0l5.8-5.8a1.172,1.172,0,0,0,0-1.657Zm-9.115,1.657a.586.586,0,1,1,0-.829A.586.586,0,0,1,4.486,162.816Zm.829-1.657a.586.586,0,1,1,.829,0A.586.586,0,0,1,5.315,161.159ZM6.972,165.3a.586.586,0,1,1,0-.829A.586.586,0,0,1,6.972,165.3Zm0-5.8a.586.586,0,1,1,.829,0A.586.586,0,0,1,6.972,159.5Zm1.657,4.143a.586.586,0,1,1,0-.829A.586.586,0,0,1,8.63,163.645Zm1.657-1.657a.586.586,0,1,1,0-.829A.586.586,0,0,1,10.287,161.987Z",
    transform: "translate(0 -148.96)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTimeLimit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_time_limit.8d2bad498e18e65f497053bd786acc80.svg";